var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMove(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14 7.00001L11.5 4.5V6.50001L7.50001 6.5V2.5H9.5L7.00004 0L4.5 2.5H6.50004V6.5L2.5 6.50001V4.5L0 7.00001L2.5 9.5V7.50002L6.50004 7.50001L6.50001 11.5H4.5L7.00004 14L9.5 11.5H7.50001L7.50005 7.49997L11.5 7.49999V9.5L14 7.00001Z",
    fill: "#003E6B"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMove);
export default __webpack_public_path__ + "static/media/move.e08d189259a528024ebd6ac3a6320ef7.svg";
export { ForwardRef as ReactComponent };